var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fixed inset-0 flex items-center justify-center",staticStyle:{"z-index":"-1","background-image":"url('/img/bg.jpg')","background-size":"cover","background-position":"center center"}},[_c(_setup.LoadingCircle)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }